module.exports = __webpack_public_path__ + "img/nofireworks.572667ce.svg";